document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.brand-collection-section').forEach(section => {
    const wrapper = section.querySelector('.brand-collection-wrapper');
    const prev = section.querySelector('.brand-arrow.prev');
    const next = section.querySelector('.brand-arrow.next');
    if (!wrapper) return;

    const scrollAmount = () => {
      const item = section.querySelector('.brand-item');
      return item ? item.offsetWidth + 24 : 200;
    };

    prev?.addEventListener('click', () => {
      wrapper.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      wrapper.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    /* Mouse wheel scrolls the slider sideways (desktop only) */
    wrapper.addEventListener('wheel', (e) => {
      if (window.innerWidth < 768) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; // trackpad sideways: native

      const max = wrapper.scrollWidth - wrapper.clientWidth;
      if (max <= 0) return; // everything fits, let the page scroll

      const atStart = wrapper.scrollLeft <= 0 && e.deltaY < 0;
      const atEnd = wrapper.scrollLeft >= max - 1 && e.deltaY > 0;
      if (atStart || atEnd) return; // at the edge, let the page scroll

      e.preventDefault();
      wrapper.scrollLeft += e.deltaY;
    }, { passive: false });
  });
});